import React from 'react';
import Icon from '../AppIcon';

const GenerationProgressIndicator = ({ progress = 0, currentStep = 0, estimatedTime = 0, steps = [] }) => {
  const defaultSteps = [
    { id: 1, label: 'Analyzing prompt', icon: 'Brain' },
    { id: 2, label: 'Generating structure', icon: 'FolderTree' },
    { id: 3, label: 'Creating components', icon: 'Code2' },
    { id: 4, label: 'Optimizing code', icon: 'Sparkles' },
    { id: 5, label: 'Finalizing project', icon: 'CheckCircle2' }
  ];

  const progressSteps = steps?.length > 0 ? steps : defaultSteps;
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  const formatTime = (seconds) => {
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  const getStepStatus = (stepId) => {
    if (stepId < currentStep) return 'completed';
    if (stepId === currentStep) return 'active';
    return 'pending';
  };

  return (
    <div className="progress-container">
      <div className="w-full max-w-2xl">
        <div className="mb-8">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-lg font-semibold">Generating Your Project</h3>
            <span className="text-sm text-muted-foreground">
              {clampedProgress}% Complete
            </span>
          </div>
          <div className="progress-bar">
            <div
              className="progress-bar-fill"
              style={{ width: `${clampedProgress}%` }}
            />
          </div>
          {estimatedTime > 0 && (
            <p className="text-sm text-muted-foreground mt-2 text-center">
              Estimated time remaining: {formatTime(estimatedTime)}
            </p>
          )}
        </div>

        <div className="space-y-3">
          {progressSteps?.map((step) => {
            const status = getStepStatus(step?.id);
            return (
              <div
                key={step?.id}
                className={`progress-step ${status}`}
              >
                <div className="flex-shrink-0">
                  {status === 'completed' ? (
                    <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center">
                      <Icon name="Check" size={16} color="#FFFFFF" />
                    </div>
                  ) : status === 'active' ? (
                    <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center animate-pulse-subtle">
                      <Icon name={step?.icon} size={16} color="#FFFFFF" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-muted flex items-center justify-center">
                      <Icon name={step?.icon} size={16} className="text-muted-foreground" />
                    </div>
                  )}
                </div>
                <div className="flex-1">
                  <p className="font-medium">{step?.label}</p>
                  {step?.description && (
                    <p className="text-sm text-muted-foreground mt-1">
                      {step?.description}
                    </p>
                  )}
                </div>
                {status === 'active' && (
                  <div className="flex-shrink-0">
                    <div className="animate-spin">
                      <Icon name="Loader2" size={20} />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GenerationProgressIndicator;